import Component from '@glimmer/component'
import { action } from '@ember/object'
import { service } from '@ember/service'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import config from 'teacher-ui-client/config/environment'
import { on } from '@ember/modifier'
import { eq } from 'ember-truth-helpers'
import type WindowService from 'teacher-ui-client/services/window'

interface Signature {
  Element: HTMLDivElement
}

export class ContentfulSelect extends Component<Signature> {
  @service contentfulClient!: ContentfulClient

  @service window!: WindowService

  get showSelect() {
    return config.contentful.showSelector
  }

  get selectedEnvironment() {
    return this.window.getWindow.localStorage.getItem('teacher-ui-client.contentful.selected-environment')
  }

  get availableEnvironments() {
    return this.contentfulClient.availableEnvironments
  }

  get usePreview() {
    return this.window.getWindow.localStorage.getItem('teacher-ui-client.contentful.use-preview') === 'true'
  }

  get showEditLinks() {
    return this.contentfulClient.showEditLinks
  }

  @action
  setEnvironment(event: Event) {
    const environmentId = (event.target as HTMLInputElement | null)?.value
    if (!environmentId) return

    this.window.getWindow.localStorage.setItem('teacher-ui-client.contentful.selected-environment', environmentId)
    this.window.getWindow.location.replace('/')
  }

  @action
  setPreview(event: Event) {
    const usePreview = (event.target as HTMLInputElement | null)?.checked
    if (typeof usePreview !== 'boolean') return

    this.window.getWindow.localStorage.setItem('teacher-ui-client.contentful.use-preview', String(usePreview))
    this.window.getWindow.location.replace('/')
  }

  @action
  setShowEditLinks(event: Event) {
    const showEditLinks = (event.target as HTMLInputElement | null)?.checked
    if (typeof showEditLinks !== 'boolean') return

    this.contentfulClient.showEditLinks = showEditLinks
  }

  <template>
    {{! template-lint-disable no-bare-strings }}
    {{#if this.showSelect}}
      <div ...attributes>
        Contentful:
        {{! template-lint-disable require-input-label }}
        <select {{on "input" this.setEnvironment}}>
          {{#each this.availableEnvironments as |env|}}
            <option value={{env}} selected={{eq this.selectedEnvironment env}}>{{env}}</option>
          {{/each}}
        </select>
        <span class="mx-2 border-l-2 border-black"></span>
        Preview:
        <input data-test-set-preview type="checkbox" checked={{this.usePreview}} {{on "input" this.setPreview}} />
        <span class="mx-2 border-l-2 border-black"></span>
        Edit links:
        <input
          data-test-show-edit-links
          type="checkbox"
          checked={{this.showEditLinks}}
          {{on "input" this.setShowEditLinks}}
        />
      </div>
    {{/if}}
  </template>
}

export default ContentfulSelect
